import { Box, Container, Typography, Link, Grid } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { navigationItems } from '@/data/navigation'
import { CONTACT_INFO, COPYRIGHT } from '@/utils/constants'

/**
 * Site Footer Component
 * Dark footer with links, contact info, and copyright
 */
export const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'grey.900',
        color: 'grey.100',
        py: { xs: 6, md: 8 },
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: 'primary.light',
                mb: 2,
              }}
            >
              Leru Systems
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: 'grey.400',
                mb: 2,
              }}
            >
              Websites that help plumbing companies get more calls
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                mb: 2,
              }}
            >
              Quick Links
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
              }}
            >
              {navigationItems.map((item) => (
                <Link
                  key={item.href}
                  component={RouterLink}
                  to={item.href}
                  underline="hover"
                  sx={{
                    color: 'grey.400',
                    fontSize: '0.875rem',
                    '&:hover': {
                      color: 'primary.light',
                    },
                  }}
                >
                  {item.label}
                </Link>
              ))}
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} sm={6} md={4}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                mb: 2,
              }}
            >
              Contact
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: 'grey.400',
                }}
              >
                Email:{' '}
                <Link
                  href={`mailto:${CONTACT_INFO.EMAIL}`}
                  sx={{
                    color: 'primary.light',
                    textDecoration: 'none',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                  }}
                >
                  {CONTACT_INFO.EMAIL}
                </Link>
              </Typography>
            </Box>
          </Grid>
        </Grid>

        {/* Bottom Bar */}
        <Box
          sx={{
            borderTop: '1px solid',
            borderColor: 'grey.800',
            mt: 4,
            pt: 3,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: 'grey.500',
              textAlign: { xs: 'center', sm: 'left' },
            }}
          >
            © {currentYear} {COPYRIGHT.COMPANY}. All rights reserved.
          </Typography>

          {/* Legal Links */}
          <Box
            sx={{
              display: 'flex',
              gap: 3,
            }}
          >
            <Link
              href="#"
              underline="hover"
              sx={{
                color: 'grey.500',
                fontSize: '0.875rem',
                '&:hover': {
                  color: 'grey.300',
                },
              }}
            >
              Privacy Policy
            </Link>
            <Link
              href="#"
              underline="hover"
              sx={{
                color: 'grey.500',
                fontSize: '0.875rem',
                '&:hover': {
                  color: 'grey.300',
                },
              }}
            >
              Terms of Service
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  )
}
